exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n#set-object-form {\n  padding-left: 1em;\n  padding-right: 1em;\n}\n", ""]);

// exports
